export const globalModalsConfig = {
  support: {
    component: 'SupportGlobalModal',
    query: '',
    private: false,
  },
  accountBlocked: {
    component: 'AccountBlockedGlobalModal',
    query: 'accountBlocked',
    private: false,
  },
  userHasBeenLoggedOut: {
    component: 'UserHasBeenLoggedOutGlobalModal',
    query: 'userHasBeenLoggedOut',
    private: false,
  },
  promoCode: {
    component: 'PromocodeGlobalModal',
    query: 'promoCode',
    private: true,
    events: {
      featurePromocodeSuccess: 'featurePromocodeSuccess',
    },
  },
  redirectVerification: {
    component: 'RedirectVerificationGlobalModal',
    query: 'redirect-verify',
    private: false,
  },
  redirectReVerification: {
    component: 'RedirectReVerificationGlobalModal',
    query: '',
    private: false,
  },
  redirectVerificationError: {
    component: 'RedirectVerificationErrorGlobalModal',
    query: '',
    private: false,
  },
}
